if (!customElements.get('primary-hero')) {
  class PrimaryHero extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.querySelectorAll('.hero-video').forEach((video) => {
        if (video.readyState >= 2) {
          this.showVideo(video);
        } else {
          video.addEventListener('canplay', () => this.showVideo(video), { once: true });
        }
      });
    }

    showVideo(video) {
      video.classList.remove('opacity-0');
    }
  }

  customElements.define('primary-hero', PrimaryHero);
}
